// ##############################
// // // Info component styles
// #############################

import {
  primaryColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  title,
} from '../../material-kit-pro-react.jsx'

const infoStyle = {
  infoArea: {
    maxWidth: '360px',
    padding: '5px 0 0',
  },
  iconWrapper: {
    float: 'left',
    marginTop: '0',
    marginRight: '10px',
  },
  primary: {
    color: primaryColor,
  },
  warning: {
    color: warningColor,
  },
  danger: {
    color: dangerColor,
  },
  success: {
    color: successColor,
  },
  info: {
    color: infoColor,
  },
  rose: {
    color: roseColor,
  },
  gray: {
    color: grayColor,
  },
  icon: {
    width: '2.25rem',
    height: '2.25rem',
    fontSize: '2.25rem',
  },
  descriptionWrapper: {
    color: 'white',
    overflow: 'hidden',
  },
  title: {
    ...title,
    margin: '4px 0 0.875rem !important',
    minHeight: 'unset',
  },
  description: {
    color: infoColor,
    overflow: 'hidden',
    marginTop: '0px',
    '& p': {
      color: grayColor,
      fontSize: '14px',
    },
  },
  iconWrapperVertical: {
    float: 'none',
  },
  iconVertical: {
    width: '61px',
    height: '61px',
  },
}

export default infoStyle



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-pro-react/components/infoStyle.jsx